<template>	
<div class="row bs-wizard" style="border-bottom:0;">
  <div class="bs-wizard-step col" :class="[currentStep > (step+1) ? 'complete' : '', currentStep == (step+1) ? 'active' : '', currentStep < (step+1) ? 'disabled' : '']" v-for="step in steps" :key="step" @click="stepClick(step)" >
    <div class="progress">
      <div class="progress-bar">
      </div>
    </div>
    <div class='slot-wrapper'><slot :name="step+1"></slot></div>
    <a class="bs-wizard-dot">
      <strong>{{step + 1}}</strong>
    </a>
  </div>
</div>
</template>

<script>
export default {
  name: 'StepBar',
  props: {
    currentStep: Number,
    maxStep: Number
  },
  methods: {
    stepClick (s) {
      this.$emit('step_clicked', s)
    }
  },
  computed: {
    steps () {
      return [...Array(this.maxStep).keys()]
    },
    gridClass () {
      let colSize = 12
      let gridClass = 'col-' + parseInt(colSize / this.maxStep)
      return gridClass
    }
  }
}
</script>

<style lang="less">
.bs-wizard {margin-top: 0px;}

/*Form Wizard*/
.bs-wizard {border-bottom: solid 1px #e0e0e0; padding: 0 0 10px 0;}
.bs-wizard > .bs-wizard-step {padding: 0; position: relative;}
.bs-wizard > .bs-wizard-step .bs-wizard-stepnum {color: #595959; font-size: 16px; margin-bottom: 5px;}
.bs-wizard > .bs-wizard-step .bs-wizard-info {color: #999; font-size: 14px;}
.bs-wizard > .bs-wizard-step > .bs-wizard-dot {position: absolute; width: 30px; height: 30px; display: block; background: #2d3e70; top: 10px; left: 50%; margin-top: 0px; margin-left: -15px; border-radius: 50%; color: #fff;  text-align: center; line-height: 30px;} 
/* .bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {content: ' '; width: 14px; height: 14px; background: #fbbd19; border-radius: 50px; position: absolute; top: 8px; left: 8px; } */
.bs-wizard > .bs-wizard-step > .progress {position: relative; border-radius: 0px; height: 8px; box-shadow: none; margin: 20px 0; background-color: #dfe1e2;}
.bs-wizard > .bs-wizard-step > .progress > .progress-bar {width:0px; box-shadow: none; background: #2d3e70;}
.bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {width:100%;}
.bs-wizard > .bs-wizard-step.active > .bs-wizard-dot { border: solid 4px #85ace7; width: 36px; height: 36px; top: 6px; line-height: 28px;}
.bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {width:50%;}
.bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {width:0%;}
.bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {width: 100%;}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {background-color: #fff; border: 1px solid #2d3e70; color: #2d3e70; line-height: 28px;}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {opacity: 0;}
.bs-wizard > .bs-wizard-step:first-child  > .progress {left: 50%; width: 50%;}
.bs-wizard > .bs-wizard-step:last-child  > .progress {width: 50%;}
.bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot{ pointer-events: none; }
.bs-wizard-step:hover {
  color: orange !important;
  cursor: pointer;
}

.slot-wrapper {
  text-align: center;
  padding: 0 0.3rem;
}
/*END Form Wizard*/
</style>



// WEBPACK FOOTER //
// StepBar.vue?d0eebd4c